import { createElement } from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

const SKILLED_USERS_SPEC_TYPES = ['library', 'language', 'technique'];

const skilledUsersCard = EntityCardBlueprint.make({
  name: 'skilled-users-card',
  params: {
    type: 'content',    
    filter: entity =>
      entity.kind === 'Component' &&
      SKILLED_USERS_SPEC_TYPES.includes((entity.spec?.type as string) ?? ''),
    loader: async () => {
      const { SkilledUsersComponent } = await import('./components/SkilledUsersComponent');
      return createElement(SkilledUsersComponent);
    },
  },
});

export const catalogModuleSkilledUsersCard = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    skilledUsersCard,
  ],
});
